<template>
    <div class="main">
        <header>
            <a class="header_logo" href="https://www.ubiquitous-p.com/">
                <img src="../assets/logo.jpg">
            </a>
            <div class="header_right">
                <router-link class="header_link" to="/ubiadmin/AdminStaffList">スタッフー覧</router-link>
                <router-link class="header_link" to="/ubiadmin/AdminNewsList">ニュース一覧/編集</router-link>
                <p>{{$store.state.userName}}</p>
                <button class="logout_btn" v-on:click="logout">ログアウト</button>
            </div>
        </header>
        <h1>ニュース一覧/編集</h1>
        <div class="search_register_btn">
            <div class="search_wrap">
                <p class="interval">配信タイトル</p>
                <input placeholder="検索" class="interval" type="text" v-model="search">
            </div>
            <router-link class="register_btn" to="/ubiadmin/AdminNewsEdit">新規登録</router-link>
        </div>
        <div class="number">
            <p>{{ getMinPage }}〜{{ getMaxPage }}／{{ get_page }}件</p>
        </div>
        <div class="news_list_tables">
            <table>
                <tr class="header_tr">
                    <th class="small_list">配信ID</th>
                    <th>配信日時</th>
                    <th>配信タイトル</th>
                    <th class="small_list">添付</th>
                    <th>作成者</th>
                    <th>作成日時</th>
                    <th>更新者</th>
                    <th>更新日時</th>
                </tr>
            </table>
            <div class="news_list">
                <table>
                  <p v-if="getLists==''">データがありません</p>
                    <tr v-for="e in getLists" :key="e.notice_id">
                        <td class="small_list">{{ e.notice_id }}</td>
                        <td>{{ e.post_date | moment("YYYY/MM/DD") }}<br>{{ e.post_date | moment("HH:mm:ss") }}</td>
                        <td>
                            <router-link :to="{name: 'AdminNewsEdit2', query: {id: e.notice_id }}" v-html="highLight(e.title)"></router-link>
                        </td>
                        <td class="small_list" v-bind:class=" e.attached_flg == true ? '' : 'false' ">
                            <img src="../assets/img/clip.png">
                        </td>
                        <td>{{ e.create_user }}</td>
                        <td>{{ e.create_date | moment("YYYY/MM/DD") }}<br>{{ e.create_date | moment("HH:mm:ss") }}</td>
                        <td>{{ e.update_user }}</td>
                        <td>{{ e.update_date | moment("YYYY/MM/DD") }}<br>{{ e.update_date | moment("HH:mm:ss") }}</td>
                    </tr>
                </table>
            </div>
        </div>
        <paginate
            :v-model="currentPage"
            :page-count="getPageCount"
            :click-handler="clickCallback"
            :page-range="3"
            :margin-pages="2"
            :prev-text="'<<'"
            :next-text="'>>'"
            :container-class="'pagination'"
            :page-link-class="'page-link'"
            :hide-prev-next="true"
            >
        </paginate>
        <div class="back_btn">
            <router-link to="/ubiadmin/AdminTop">戻る</router-link>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      tweets: [],
      search: '',
      currentPage: 1,
      parPage: 50,
      get_page: 0,
      url_protcol: 'https://',
      domain: '1304kanri.ubiquitous-p.com',
      url_path: '/rest/get_notice_admin_list/'
    }
  },
  mounted () {
    this.fetchTweets() // fetchTweetsを呼ぶ
  },
  methods: {
    fetchTweets () {
      axios
        .post(this.url_protcol + this.domain + this.url_path,{},{
          headers: {
                    "Content-Type": "application/json", 
                    "Authorization": this.$store.state.userToken 
                }
        })
        .then(response => {
          this.tweets = response.data
          this.get_page = response.data.length
        })
    },
    clickCallback: function (pageNum) {
      this.currentPage = Number(pageNum)
    },
    highLight (text) {
      let searchWord = this.search.trim()
      if (searchWord === '') return text
      if (!text.includes(searchWord)) return text
      const re = new RegExp(searchWord, 'ig')
      return text.replace(re, function (search) {
        return '<span style="background-color:#fbbe4e;font-weight:bold">' + search + '</span>'
      })
    },
    logout() {
        this.$store.commit('reset');
        this.$router.push({name:'aLogin'});
    }
  },
  computed: {
    getItems () {
      let searchWord = this.search.trim()
      if (searchWord === '') return this.tweets
      return this.tweets.filter(e => {
        return e.title.includes(searchWord)
      })
    },
  getLists: function () {
      let current = this.currentPage * this.parPage
      let start = current - this.parPage
      return this.getItems.sort((a, b) => {
          return (a.notice_id > b.notice_id) ? -1 : (a.notice_id < b.notice_id) ? 1 : 0;
        }).slice(start, current);
    },
    getPageCount: function () {
      return Math.ceil(this.getItems.length / this.parPage)
    },
    getMaxPage: function () {
      if (this.getLists.length === 50) {
        let max = this.currentPage * 50
        return max
      } else {
        let page = this.currentPage - 1
        let max = 50 * page + this.getLists.length
        return max
      }
    },
    getMinPage: function () {
      if (this.getLists.length === 0) {
        return 0
      } else {
        let min = 50 * this.currentPage - 49
        return min
      }
    }
  },
  watch: {
    search: function () {
      this.currentPage = 1
    }
  }
}
</script>

<style scoped>

.main {
    width: 100vw;
    background-size: cover;
}

a.register_btn {
    width: fit-content;
    display: block;
    background-color: #4DC0AD;
    color: #fff;
    border-radius: 10px;
    box-shadow: rgb(158 158 158) 1px 1px 3px;
    text-decoration: none;
    padding: 7px 40px;
    margin-left: auto;
}

h1 {
    margin: 5px 40px;
}

.search_register_btn {
    display: flex;
    width: 95vw;
    margin: 20px auto 0;
}

.search_wrap {
    display: flex;
    align-items: center;
}

.search_wrap button {
    width: fit-content;
    display: block;
    background-color: #4DC0AD;
    color: #fff;
    border-radius: 10px;
    box-shadow: rgb(158 158 158) 1px 1px 3px;
    text-decoration: none;
    padding: 5px 40px;
    margin: 0 3vw 0 auto;
    border: none;
}

.search_wrap input {
    display: block;
    width: 250px;
    height: 30px;
    padding: 0 10px;
    border-radius: 10px;
    border: 1px solid #888;
    box-shadow: rgb(210 210 210) 1px 1px 3px inset;
}

.interval {
    margin-right: 20px;
    margin-bottom: 0;
}

.number {
    text-align: right;
    margin-right: 5vw;
}

.number p {
    font-size: .7em;
    margin: 5px 0;
}

.news_list_tables {
    width: 95vw;
    margin: 0 auto;
    padding: 20px 30px;
    border: 1px solid #707070;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 0.6);
}

.news_list {
    width: 100%;
    height: 55vh;
    overflow: scroll;
}

table {
    width: 100%;
    border-collapse: collapse;
    position: relative;
}

td, tr, td a {
    font-size: .9vw;
}

tr.header_tr {
    border-top: 1px solid #707070;
}

tr {
    border-bottom: 1px solid #707070;
    height: 50px;
}

th, td {
    width: 100px;
    text-align: left;
    word-break: break-all;
}

th.small_list, td.small_list {
    width: 50px;
    text-align: center;
}

td a {
    text-decoration: underline;
    color: blue;
}

.back_btn {
    width: 90vw;
    margin: 0 auto;
    padding: 15px;
}

.back_btn a {
    display: block;
    width: 150px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background-color: #4DC0AD;
    color: #fff;
    text-decoration: none;
    border-radius: 15px;
    margin: 5px 0;
    font-size: inherit;
}

td img {
    width: 2vw;
}

.false img {
    display: none;
}

.false::after {
    content: 'ー';
}

ul.pagination {
    width: fit-content;
    display: flex;
    margin: 2vw auto 0;
}

/* ul.pagination li {
    display: block !important;
    width: 3vw !important;
    height: 3vw !important;
}

.active [data-v-82963a40] {
    background-color: #4DC0AD !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/AdminNewsList.vue